import { Link, useNavigate } from 'react-router-dom'
import { Button } from 'ui-components-web'
import { useForm } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormPassword } from 'components/common/form'
import User from 'singletons/User'
import { ACCOUNT } from 'constants/routing'
import { ChangePasswordSchema } from 'schemas/ChangePassword'

import ErrorFieldForm from 'components/UI/ErrorFieldForm'
import useStyles from './styles'

const ChangePassword = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, isDirty, errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(ChangePasswordSchema),
  })

  return (
    <div className={classes.changePasswordContainer}>
      <form
        className={classes.changePasswordForm}
        onSubmit={handleSubmit(async ({ oldPassword, password }) => {
          await User.updatePassword(password, oldPassword)
          navigate(ACCOUNT)
        })}
      >
        <div className={classes.passwordInputSection}>
          <FormPassword
            variant={'outlined'}
            fullWidth
            label={'Old password'}
            autoComplete={'old-password'}
            {...register('oldPassword')}
            data-testid={'input-old-password'}
          />
          <ErrorMessage errors={errors} name="oldPassword" as={<ErrorFieldForm />} />
        </div>

        <div className={classes.passwordInputSection}>
          <FormPassword
            variant={'outlined'}
            fullWidth
            label={'New password'}
            autoComplete={'new-password'}
            {...register('password')}
            data-testid={'input-new-password'}
          />
          <ErrorMessage errors={errors} name="password" as={<ErrorFieldForm />} />
        </div>

        <div className={classes.passwordInputSection}>
          <FormPassword
            variant={'outlined'}
            fullWidth
            label={'Confirm password'}
            autoComplete={'new-password'}
            {...register('confirmPassword')}
            data-testid={'input-confirm-password'}
          />
          <ErrorMessage errors={errors} name="confirmPassword" as={<ErrorFieldForm />} />
        </div>

        <div className={classes.actionsContainer}>
          <Link to={ACCOUNT} className={classes.link}>
            <Button color={'primary'}>Cancel</Button>
          </Link>

          <Button
            disabled={!isDirty || isSubmitting}
            type={'submit'}
            variant={'contained'}
            color={'primary'}
            className={classes.saveChangesButton}
          >
            Save changes
          </Button>
        </div>
      </form>
    </div>
  )
}

export default ChangePassword
